export const GET_INVOICES = "/payments/";
export const DOWNLOAD_INVOICE = "/payments/adviser_download/:id/:paymentId/";
export const UPDATE_INVOICE = "/payments/:id/:paymentId/update/";
